import Card from '../components/common/Card';

export default function Gallery() {
  return (
    <div className="min-h-screen py-16 bg-gradient-to-br from-lavender-light via-cream to-mint-light">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl md:text-5xl text-center mb-12 text-gray-800">
          Photo Gallery
        </h1>

        <Card className="max-w-4xl mx-auto text-center">
          <div className="text-6xl mb-6">📸</div>
          <h2 className="text-2xl mb-4 text-lavender-dark">Coming Soon</h2>
          <p className="text-gray-700">
            Add your engagement photos or venue pictures here!
          </p>
          <p className="text-sm text-gray-500 mt-4">
            Images can be placed in <code className="bg-gray-100 px-2 py-1 rounded">frontend/public/</code> directory
          </p>
        </Card>
      </div>
    </div>
  );
}
